import {gql} from 'apollo-boost'

export const GET_LAWYER = gql`
  query getLawyer($id: ID!) {
    getLawyer(
      id: $id
    ){
      id
      sequence
      isChoose
      prefix{
        id
        nameTh
      }
      name
      surname
      idCardNumber
      lawyerNumber
      phone
      mobile
      email
      address{
        location
        houseNumber
        moo
        alley
        road
        subDistrict
        district
        province
        zipcode
      }
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_LAWYERS = gql`
  query getLawyers {
    getLawyers{
      id
      sequence
      isChoose
      prefix{
        id
        nameTh
      }
      name
      surname
      idCardNumber
      lawyerNumber
      phone
      mobile
      email
      address{
        location
        houseNumber
        moo
        alley
        road
        subDistrict
        district
        province
        zipcode
      }
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_LAWYER_OPTIONS = gql`
  query getLawyerOptions {
    getLawyers{
      id
      fullName
      isChoose
      status
    }
  }
`

export const CREATE_LAWYER = gql`
  mutation createLawyer($payload: LawyerInput!) {
    createLawyer(
      payload: $payload
    ){
      id
      sequence
      isChoose
      prefix{
        id
        nameTh
      }
      name
      surname
      idCardNumber
      lawyerNumber
      phone
      mobile
      email
      address{
        location
        houseNumber
        moo
        alley
        road
        subDistrict
        district
        province
        zipcode
      }
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_LAWYER = gql`
  mutation updateLawyer($id: ID!, $payload: LawyerInput!) {
    updateLawyer(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      prefix{
        id
        nameTh
      }
      name
      surname
      idCardNumber
      lawyerNumber
      phone
      mobile
      email
      address{
        location
        houseNumber
        moo
        alley
        road
        subDistrict
        district
        province
        zipcode
      }
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_LAWYER = gql`
  mutation deleteLawyer($id: ID!) {
    deleteLawyer(
      id: $id
    ) {
      id
    }
  }
`

export const GET_PROSECUTION = gql`
  query getProsecution($id: ID!) {
    getProsecution(
      id: $id
    ){
      id
      # ข้อมูลทั่วไป
      caseDate
      caseNumber
      lawyer{
        id
        fullName
      }
      borrower{
        id
        idCardNumber
        fullName
        phone
        mobile
        project{
          id
          nameTh
        }
      }
      contract {
        id
        contractDate
        contractNo
        contractName
        periodTermStart
        periodYearStart
        periodTermEnd
        periodYearEnd
        curriculum{
          nameTh
          faculty{
            nameTh
          }
        }
        loan {
          loanTypeName
        }
        restructuringDetail{
          contracts{
            id
            contractNo
            contractName
            prosecution{
              id
            }
          }
        }
      }
      sureties{
        id
        seq
        surety{
          id
          fullName
        }
      }
      contractDate
      curriculumName
      firstMissedAppointmentDate
      firstCollectionFeeLetterDate
      sendCollectionFeeLetterCount
      # หนี้ค้างชำระ ส่งฝ่ายกฎหมาย
      dateOfBalanceExtraction
      principle
      interest
      penalty
      fee
      expenseDetailAmount
      collectionFee
      lawyerFee
      total
      #รายละเอียดการดำเนินคดี
      lawyerAcceptedDate #วันที่ทนายรับเรื่อง
      lawyerSendInquiryLetterDate #วันที่ทนายส่งหนังสือทวงถาม
      dateOfFiling
      principleFiling
      interestFiling
      penaltyFiling
      feeFiling
      expenseDetailAmountFiling
      collectionFeeFiling
      lawyerFeeFiling
      claimAmount
      #ค่าใช้จ่ายในการดำเนินคดี
      blackCaseNumber
      dateOfCourtFiling
      court
      courtFee
      documentFee
      sendOpponentFee
      sendEnforcementFee
      totalExpenseAmount
      #คำพิพากษา
      redCaseNumber
      dateOfCourtJudgment
      prosecutionResult
      prosecutionResultDescription
      prosecutionReasonDescription
      principleAfter
      interestAfter
      penaltyAfter
      feeAfter
      expenseDetailAmountAfter #ค่าใช้จ่ายอื่นๆ
      collectionFeeAfter
      lawyerFeeAfter #ค่าทนาย หรือค่าใช้จ่ายในการดำเนินคดี (ที่ระบุไว้ในสัญญา)
      attorneyFeeByCourt #ค่าทนายตามคำสั่งศาล
      expenseAmountAfter #ต่าฤชาธรรมเนียม
      courtFeeReturn
      totalAfter
      # สถานะการดำเนินคดี
      date
      prosecutionType
      prosecutionStatus
      prosecutionStatusText
      caseStatus
      remark
      # อื่นๆ
      status
      details{
        id
        seq
        date
        caseStatus
        caseStatusName
        remark
        createdAtLocal: createdAt(local: false, format: "DD-MM-YYYY HH.mm น.")
        createdAt
        createdBy{
          fullName
        }
        files{
          id
          seq
          description
          fileName
          fileType
          pathUrl
          status
          fileCategory
          fileFrom
          createdAt
          updatedAt
          borrower{
            id
          }
          surety{
            id
          }
          createdBy{
            id
          }
          updatedBy{
            id
          }
        }
      }
      files{
        id
        seq
        description
        fileName
        fileType
        pathUrl
        status
        fileCategory
        fileFrom
        createdAt
        updatedAt
        borrower{
          id
        }
        surety{
          id
        }
        createdBy{
          id
        }
        updatedBy{
          id
        }
      }
      # custom field
      prosecutionResultName
      lawyerEmail
      prosecutionTypeName
    }
  }
`

export const GET_PROSECUTION_USER_JOB = gql`
  query getProsecution($id: ID!) {
    getProsecution(
      id: $id
    ){
      id
      # ข้อมูลทั่วไป
      caseDate
      caseNumber
      lawyer{
        id
        fullName
      }
      borrower{
        id
        idCardNumber
        fullName
      }
      contract {
        id
        contractNo
        contractName
      }
      sureties{
        id
        seq
        surety{
          id
          fullName
        }
      }
      contractDate
      curriculumName
      firstMissedAppointmentDate
      firstCollectionFeeLetterDate
      sendCollectionFeeLetterCount
      # ทหนี้ค้างชำระ ส่งฝ่ายกฎหมาย
      dateOfBalanceExtraction
      principle
      interest
      penalty
      fee
      expenseDetailAmount
      collectionFee
      lawyerFee
      total
      # อื่นๆ
      status
    }
  }
`

export const GET_PROSECUTION_LAWYER_JOB = gql`
  query getProsecution($id: ID!) {
    getProsecution(
      id: $id
    ){
      id
      #รายละเอียดการดำเนินคดี
      lawyerAcceptedDate #วันที่ทนายรับเรื่อง
      lawyerSendInquiryLetterDate #วันที่ทนายส่งหนังสือทวงถาม
      dateOfFiling
      principleFiling
      interestFiling
      penaltyFiling
      feeFiling
      expenseDetailAmountFiling
      collectionFeeFiling
      lawyerFeeFiling
      claimAmount
      #ค่าใช้จ่ายในการดำเนินคดี
      blackCaseNumber
      dateOfCourtFiling
      court
      courtFee
      documentFee
      sendOpponentFee
      sendEnforcementFee
      totalExpenseAmount
      #คำพิพากษา
      redCaseNumber
      dateOfCourtJudgment
      prosecutionResult
      prosecutionResultDescription
      prosecutionReasonDescription
      principleAfter
      interestAfter
      penaltyAfter
      feeAfter
      expenseDetailAmountAfter #ค่าใช้จ่ายอื่นๆ
      collectionFeeAfter
      lawyerFeeAfter #ค่าทนาย หรือค่าใช้จ่ายในการดำเนินคดี (ที่ระบุไว้ในสัญญา)
      attorneyFeeByCourt #ค่าทนายตามคำสั่งศาล
      expenseAmountAfter #ต่าฤชาธรรมเนียม
      courtFeeReturn
      totalAfter
      # ข้อมูลทั่วไป
      status
    }
  }
`

export const GET_PROSECUTIONS = gql`
  query getProsecutions {
    getProsecutions {
      id
      contract{
        id
      }
      caseNumber
      caseDate
      dateOfCourtFiling
      dateOfCourtJudgment
      totalExpenseAmount
      claimAmount
      total
      caseStatus
      status
      createdAt
      updatedAt
      createdBy {
        id
      }

      ## custom field
      idCardNumber
      fullName
      contractNo
      contractName
      lawyerEmail
      caseStatusName
    }
  }
`

export const GET_PROSECUTIONS_USER_JOB = gql`
  query getProsecutionsUserJob {
    getProsecutionsUserJob {
      id
      contract{
        id
      }
      prosecutionType
      caseNumber
      sendInformationContractToLawyerDate
      total
      caseStatus
      createdAt
      createdBy {
        id
      }

      ## custom field
      fullName
      contractNo
      contractName
      lawyerEmail
      caseStatusName
      prosecutionTypeName
    }
  }
`

export const GET_PROSECUTIONS_LAWYER_JOB = gql`
  query getProsecutionsLawyerJob($isLawyer: Boolean) {
    getProsecutionsLawyerJob(isLawyer: $isLawyer) {
      id
      contract{
        id
      }
      prosecutionType
      caseNumber
      caseDate
      lawyerAcceptedDate
      lawyerSendInquiryLetterDate
      total
      caseStatus
      createdAt
      createdBy {
        id
      }

      ## custom field
      fullName
      contractNo
      contractName
      lawyerEmail
      caseStatusName
      prosecutionTypeName
    }
  }
`

export const GET_PROSECUTIONS_CLOSE_CANCEL_HOLD = gql`
  query getProsecutionsCloseCancelHold($isLawyer: Boolean) {
    getProsecutionsCloseCancelHold(isLawyer: $isLawyer) {
      id
      contract{
        id
      }
      prosecutionType
      caseNumber
      date # statusDate
      total
      totalExpenseAmount
      totalAfter
      caseStatus
      createdAt
      createdBy {
        id
      }

      ## custom field
      fullName
      contractNo
      contractName
      lawyerEmail
      caseStatusName
      prosecutionTypeName
    }
  }
`

export const CREATE_PROSECUTION = gql`
  mutation createProsecution($payload: ProsecutionInput!) {
    createProsecution(
      payload: $payload
    ){
      id
    }
  }
`

export const UPDATE_PROSECUTION_USER_JOB = gql`
  mutation updateProsecutionUserJob($id: ID!, $payload: ProsecutionInput!) {
    updateProsecutionUserJob(
      id: $id
      payload: $payload
    ){
      id
    }
  }
`

export const UPDATE_PROSECUTION_LAWYER_JOB = gql`
  mutation updateProsecutionLawyerJob($id: ID!, $payload: ProsecutionInput!) {
    updateProsecutionLawyerJob(
      id: $id
      payload: $payload
    ){
      id
    }
  }
`

export const UPDATE_PROSECUTION_CASE_STATUS = gql`
  mutation updateProsecutionCaseStatus($id: ID!, $payload: ProsecutionInput!) {
    updateProsecutionCaseStatus(
      id: $id
      payload: $payload
    ){
      id
    }
  }
`

export const DELETE_PROSECUTION = gql`
  mutation deleteProsecution($id: ID!) {
    deleteProsecution(
      id: $id
    ) {
      id
    }
  }
`

export const GET_PROSECUTION_DETAIL = gql`
  query getProsecutionDetail($id: ID!) {
    getProsecutionDetail(
      id: $id
    ){
      id
      date
      caseStatus
      remark
      files{
        id
        seq
        description
        fileName
        fileType
        pathUrl
        status
        fileCategory
        fileFrom
        createdAt
        updatedAt
        borrower{
          id
        }
        surety{
          id
        }
        createdBy{
          id
        }
        updatedBy{
          id
        }
      }
      prosecution{
        id
      }
    }
  }
`

export const GET_PROSECUTION_DETAILS = gql`
  query getProsecutionDetails {
    getProsecutionDetails{
      id
      prosDate
      remark
      prosStatus
      prosecution{
        borrower{
          id
          prefix{
            id
            nameTh
          }
          name
          surname
          idCardNumber
          studentCode
          project{
            id
            nameTh
          }
        }
        contract{
          id
          contractNo
          contractName
        }
        lawyer{
          id
          prefix{
            id
            nameTh
          }
          name
          surname
        }
        court{
          id
          name
        }
      }
    }
  }
`

export const CREATE_PROSECUTION_DETAIL = gql`
  mutation createProsecutionDetail($payload: ProsecutionDetailInput!) {
    createProsecutionDetail(
      payload: $payload
    ){
      id
      date
      caseStatus
      remark
      prosecution{
        id
      }
    }
  }
`

export const UPDATE_PROSECUTION_DETAIL = gql`
  mutation updateProsecutionDetail($id: ID!, $payload: ProsecutionDetailInput!) {
    updateProsecutionDetail(
      id: $id
      payload: $payload
    ){
      id
    }
  }
`

export const SOFT_DELETE_PROSECUTION_DETAIL = gql`
  mutation softDeleteProsecutionDetail($id: ID!) {
    softDeleteProsecutionDetail(
      id: $id
    ) {
      id
    }
  }
`

export const GET_FILE = gql`
  query getFile($id: ID!) {
    getFile(
      id: $id
    ){
      id
      seq
      prosecution{
        id
      }
      prosecutionDetail{
        id
      }
      description
      fileName
      fileType
      pathUrl
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_FILES = gql`
  query getFiles {
    getFiles{
      id
      seq
      prosecution{
        id
      }
      prosecutionDetail{
        id
      }
      description
      fileName
      fileType
      pathUrl
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const CREATE_FILE = gql`
  mutation createFile($payload: FileInput!) {
    createFile(
      payload: $payload
    ){
      id
      seq
      prosecution{
        id
      }
      prosecutionDetail{
        id
      }
      description
      fileName
      fileType
      pathUrl
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_FILE = gql`
  mutation updateFile($id: ID!, $payload: FileInput!) {
    updateFile(
      id: $id
      payload: $payload
    ){
      id
      seq
      prosecution{
        id
      }
      prosecutionDetail{
        id
      }
      description
      fileName
      fileType
      pathUrl
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_FILE = gql`
  mutation deleteFile($id: ID!) {
    deleteFile(
      id: $id
    ) {
      id
    }
  }
`
